import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'contact',
  templateUrl: './contact.view.html',
  styleUrls: ['./contact.view.scss']
})
export class ContactView implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
